import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CurrentsIntegrationsEditForNro = lazy(() =>
  import("@scenes/CurrentsIntegration/CurrentsIntegrationEditNRO").then((module) => ({
    default: module.CurrentsIntegrationEditNRO,
  }))
);

export const integrationsCurrentsIntegrationsEditPillNRO: NavigationRoutingObject = {
  section: "partner-integrations",
  Component: CurrentsIntegrationsEditForNro,
  componentFeatureFlippers: ["currents_integrations"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("data-export-sidebar-new-pill-menu-option", "Data Export"),
  pageNameForTracking: () => "Data Export",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("currents-description-nav", "Create and manage your Currents connections"),
  icon: "nav-system-data-export",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("currents_integrations");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/currents_integrations/:appGroupId",
};
